const date = require('locutus/php/datetime/date')

export function timeFormat(timestamp, format = 'Y-m-d H:i:s') {
    if (!timestamp) { return '-'; }
    return date(format, timestamp);
}